import React from 'react';
import { HttpClient } from '@wix/http-client';
import { MetaSiteInstanceApiClient } from '../../../apis/api-clients-react';
export const useHttpClientSiteLevel = _ref => {
  let {
    siteId,
    httpClientOptions
  } = _ref;
  const [httpClient, setHttpClient] = React.useState();
  const [error, setError] = React.useState();
  const [isLoading, setIsLoading] = React.useState(true);
  React.useEffect(() => {
    if (!httpClient) {
      setIsLoading(true);
      MetaSiteInstanceApiClient.query.getEditorClientSpecMap({
        httpClient: new HttpClient(httpClientOptions),
        request: {
          metaSiteId: siteId
        }
      }).then(res => {
        setHttpClient(new HttpClient({
          ...httpClientOptions,
          headers: {
            ...(httpClientOptions == null ? void 0 : httpClientOptions.headers),
            Authorization: res == null ? void 0 : res['-666'].instance
          }
        }));
        setTimeout(() => {
          // refresh every 4 hours
          setHttpClient(null);
        }, 1000 * 60 * 60 * 4);
        setIsLoading(false);
      }).catch(err => {
        setIsLoading(false);
        setError(err);
      });
    }
  }, [siteId, httpClient]);
  return {
    httpClient,
    error,
    isLoading
  };
};
//# sourceMappingURL=useHttpClientSiteLevel.js.map